import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'
import {FaFire} from 'react-icons/fa'

import AppContext from '../../context/AppContext'
import VideoCard from '../VideoCard'
import Header from '../Header'
import SideBar from '../SideBar'

import {
  NoSavedView,
  NoSavedViewImg,
  NoSavedViewHeading,
  NoSavedViewPara,
  SavedVideosContainer,
  SavedVideosHeader,
  SavedVideosIconContainer,
  SavedVideosIcon,
  SavedVideosPara,
  SavedVideosList,
} from './styledComponents'

const SavedVideos = props => {
  const jwtToken = Cookies.get('jwt_token')
  const {match} = props
  const {path} = match
  if (jwtToken === undefined) {
    return <Redirect to="/login" />
  }
  return (
    <div data-testid="savedVideos">
      <Header />
      <SideBar path={path} />
      <AppContext.Consumer>
        {value => {
          const {theme, savedVideoList} = value
          return savedVideoList.length === 0 ? (
            <NoSavedView theme={theme}>
              <NoSavedViewImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-saved-videos-img.png"
                alt="no saved videos"
              />
              <NoSavedViewHeading theme={theme}>
                No saved videos found
              </NoSavedViewHeading>
              <NoSavedViewPara theme={theme}>
                You can save your videos while watching them
              </NoSavedViewPara>
            </NoSavedView>
          ) : (
            <SavedVideosContainer theme={theme} data-testid="savedVideos">
              <SavedVideosHeader theme={theme}>
                <SavedVideosIconContainer theme={theme}>
                  <SavedVideosIcon fill="#ff0000" as={FaFire} />
                </SavedVideosIconContainer>
                <SavedVideosPara theme={theme}>Saved Videos</SavedVideosPara>
              </SavedVideosHeader>
              <SavedVideosList theme={theme}>
                {savedVideoList.map(each => (
                  <VideoCard videoItem={each} key={each.id} />
                ))}
              </SavedVideosList>
            </SavedVideosContainer>
          )
        }}
      </AppContext.Consumer>
    </div>
  )
}

export default SavedVideos
